import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RedDot } from './red-dot.component'
import { TooltipModule } from 'ngx-bootstrap/tooltip'

@NgModule({
  imports: [
    TooltipModule,
    CommonModule,
  ],
  declarations: [RedDot],
  exports: [RedDot]
})
export class RedDotModule {}
